var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-loader"},[(_vm.isLoading)?_c('Loading',{class:_vm.loadingClass,attrs:{"background":false}}):_vm._e(),_vm._v(" "),_c('img',{attrs:{"src":_vm.currentSrc}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28bce3f8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/v3/images/ImageLoader.vue
// module id = null
// module chunks = 